import { render } from "./UserModal.vue?vue&type=template&id=4608e732&scoped=true"
import script from "./UserModal.vue?vue&type=script&lang=js"
export * from "./UserModal.vue?vue&type=script&lang=js"

import "./UserModal.vue?vue&type=style&index=0&id=4608e732&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4608e732"]])

export default __exports__